// src/store/plugins/persistState.js
export function persistState(store) {
  // Called when the store is initialized
  const savedState = localStorage.getItem('vuex');
  if (savedState) {
    store.replaceState(JSON.parse(savedState));
  }

  // Subscribe to store mutations
  store.subscribe((mutation, state) => {
    localStorage.setItem('vuex', JSON.stringify(state));
  });
}
